import { AuthService } from "../auth/auth-service";
import { getAuthDataFromLocalStorage } from "../auth/model/auth-utils";

export interface ITermsService {
  getUserTerms(): boolean;
  updateUserTerms(): Promise<any>;
}

export class TermsService implements ITermsService {
  private readonly authService: AuthService;

  constructor() {
    this.authService = new AuthService();
  }

  getUserTerms(): boolean {
    const authData = getAuthDataFromLocalStorage();
    return authData && authData.terms || false;
  }

  async updateUserTerms(): Promise<any> {
    const authData = getAuthDataFromLocalStorage();
    if (!authData || !authData.email) {
      return { error: "User not logged in" };
    }

    return await this.authService.updateTerms(authData.email);
  }
} 